import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Link from '../../navigation/Link'

import './StoreButtonBase.scss'

const StoreButtonBase = ({
  href,
  target,
  src,
  height,
  alt,
  imageClassName,
  linkClassName
}) => (
  <Link href={href} target={target} className={classNames('store-button', linkClassName)}>
    <img
      height={height}
      className={classNames('store-button__img', imageClassName)}
      src={src}
      alt={alt}
    />
  </Link>
)

StoreButtonBase.defaultProps = {
  target: '_blank',
  imageClassName: '',
  linkClassName: '',
  height: 0,
  alt: ''
}

StoreButtonBase.propTypes = {
  imageClassName: PropTypes.string,
  linkClassName: PropTypes.string,
  href: PropTypes.string.isRequired,
  target: PropTypes.oneOf(['_self', '_blank']),
  src: PropTypes.string.isRequired,
  height: PropTypes.number,
  alt: PropTypes.string
}

export default StoreButtonBase
